/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { socketConfig } from "app/services/socket";
import ContentLayout from "./Components/ContentLayout";
import MessageCard from "./Components/MessageCard";
import Button from "app/components/UI/Button";
import { customerServices } from "app/services/api";
import { ADMIN_CHAT_ID, DEFAULT_MSG_NUMBER_PER_PAGE } from "../../constants";
import moment from "moment/moment";
import ChatBox from "./Components/ChatBox";
import { useSearchParams } from "react-router-dom";
import useVerifyToken from "../../hooks/useVerifyToken";

function ChatContent({ socket }) {
  const [searchParams] = useSearchParams();
  const [msgList, setMsgList] = useState([]);
  const [selectingId, setSelectingId] = useState(searchParams.get("id"));
  const [listContact, setListContact] = useState([]);
  const textAreaRef = useRef();
  const msgListRef = useRef(null);
  // Infinite Scroll's state
  const [listCusPage, setListCusPage] = useState(1);
  const [hasMoreCustomer, setHasMoreCustomer] = useState(true);
  // Need clear before select another
  const [isLoadingMoreMsg, setIsLoadingMoreMsg] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [prevHeight, setPrevHeight] = useState(0);
  const [msgVal, setMsgVal] = useState("");

  const [selectedChatId, setSelectedChatId] = useState(null);

  const [offsetNext, setOffsetNext] = useState(0);
  const [hasNext, setHasNext] = useState(false);
  const [isLoadingNextMsg, setIsLoadingNextMsg] = useState(false);

  const [keyword, setKeyword] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [currentMessageId, setCurrentMessageId] = useState(searchParams.get("msgId"))
  const messageId = searchParams.get("msgId")
  //Function

  const scrollBottom = () => {
    const msgListEl = document.getElementById("msg-list-id");
    msgListEl.scrollTo(0, msgListEl.scrollHeight);
  };

  const scrollToKeepCurrentPosition = (isNextMore) => {
    const msgListEl = document.getElementById("msg-list-id");

    const scrollDistance = isNextMore
      ? prevHeight
      : msgListRef?.current?.offsetHeight - prevHeight;

    setPrevHeight(msgListRef?.current?.offsetHeight);

    msgListEl.scrollTo(0, scrollDistance);
  };

  const clearStateWhenChangeObjId = () => {
    setIsLoadingMoreMsg(false);
    setOffset(0);
    setHasMore(false);
    setPrevHeight(0);
    setMsgVal("");
  };

  const handleSendMsg = () => {
    if (selectingId && msgVal) {
      socket?.emit("message", {
        message: msgVal.replaceAll("\n", "<br/>"),
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
      });

      getAllWithLastMessageApi("", true);

      textAreaRef.current.focus();
    }
  };

  const handleScrollMsgList = (e) => {
    if (e?.target.scrollTop === 0 && hasMore) {
      setOffset((prev) => prev + 1);
      setIsLoadingMoreMsg(true);
      socket?.emit("load-more-msg", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: offset + 1,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        keyword: keyword,
        chatId: selectedChatId,
      });
    }

    if (
      Math.ceil(e?.target.scrollTop + e?.target.clientHeight + 1) >= e?.target.scrollHeight &&
      hasNext
    ) {
      setOffsetNext((prev) => prev + 1);
      setIsLoadingNextMsg(true);
      socket?.emit("load-next-msg", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: offsetNext,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        chatId: selectedChatId,
      });
    }
  };

  // Hook
  function onConnect() {
    console.log("Socket connected");
  }

  function onDisconnect() {
    console.log("Socket disconnected");
  }

  function onInitMsgEvent(value) {
    console.log("Join Room");
    const { prevMsg, hasMore } = value;

    setHasMore(hasMore);
    const formattedList = prevMsg?.reverse().map((msgItem, index) => {
      const { message, fromId, toId, _id, createdAt } = msgItem || {};
      return {
        content: message,
        isIncomingMsg: fromId !== ADMIN_CHAT_ID,
        _id,
        createdAt,
        fromId,
        toId,
      };
    });
    setMsgList(formattedList);
  }

  function onLoadMoreMsgEvent(value) {
    const { prevMsg, hasMore } = value;
    setHasMore(hasMore);

    const formattedList = prevMsg?.reverse().map((msgItem, index) => {
      const { message, fromId, toId, _id, createdAt } = msgItem || {};
      return {
        content: message,
        isIncomingMsg: fromId !== ADMIN_CHAT_ID,
        _id,
        createdAt,
        fromId,
        toId,
      };
    });

    setMsgList((prev) => {
      return [...formattedList, ...prev];
    });
  }

  function onLoadNextMsgEvent(value) {
    const { nextMsg, hasNextMore } = value;
    setHasNext(hasNextMore);
    const formattedList = nextMsg?.reverse().map((msgItem, index) => {
      const { message, fromId, toId, _id, createdAt } = msgItem || {};
      return {
        content: message,
        isIncomingMsg: fromId !== ADMIN_CHAT_ID,
        _id,
        createdAt,
        fromId,
        toId,
      };
    });

    setMsgList((prev) => {
      return [...prev, ...formattedList];
    });
  }

  function onSendSuccessEvent(value) {
    const { message, fromId, toId, createdAt, _id } = value || {};
    const isIncomingMsg = fromId !== ADMIN_CHAT_ID;
    setMsgList((prev) => [
      ...prev,
      {
        content: message,
        isIncomingMsg,
        createdAt,
        _id,
        fromId,
        toId,
      },
    ]);
    setMsgVal("");

    if (isIncomingMsg) {
      getAllWithLastMessageApi(keyword, true);
    }
  }

  useEffect(() => {
    socket?.on("connect", onConnect);
    socket?.on("send-success-message", onSendSuccessEvent);
    socket?.on("load-more-msg", onLoadMoreMsgEvent);
    socket?.on("load-next-msg", onLoadNextMsgEvent);
    socket?.on("join-room", onInitMsgEvent);
    socket?.on("disconnect", onDisconnect);
    return () => {
      socket?.off("connect", onConnect);
      socket?.off("disconnect", onDisconnect);
      socket?.off("join-room", onInitMsgEvent);
      socket?.off("send-success-message", onSendSuccessEvent);
      socket?.off("load-more-msg", onLoadMoreMsgEvent);
      socket?.off("load-next-msg", onLoadNextMsgEvent);
    };
  }, [socket]);

  useEffect(() => {
    if (selectingId) {
      socket?.emit("join-room", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: 0,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        keyword: keyword,
      });
    }
    clearStateWhenChangeObjId();

    if (selectingId) {
      window.history.replaceState(null, null, `/chat?id=${selectingId}${currentMessageId ? '&msgId=' + currentMessageId : ''}`);
    } else if (messageId) {
      // do nothing
    } else {
      window.history.replaceState(null, null, `/chat`);
    }
  }, [selectingId]);


  useEffect(() => {
    if (messageId) {
      if (currentMessageId === messageId) {
        if (listCusPage == 1) {
          // get first page chat room then get target message
          getAllWithLastMessageApi(keyword);
        }
        // same messageId , so load page with listCusPage
        getAllWithLastMessageApi(keyword, false, messageId);
        setCurrentMessageId(messageId)
      } else {
        // diff messageId , so reset listCusPage = 1
        if (listCusPage != 1) {
          setListCusPage(1)
          return
        }

        getAllWithLastMessageApi(keyword, false, messageId);
        setCurrentMessageId(messageId)
      }

    } else {
      getAllWithLastMessageApi(keyword);
    }

  }, [listCusPage, messageId]);

  useEffect(() => {
    if (isLoadingMoreMsg || isLoadingNextMsg) {
      scrollToKeepCurrentPosition(isLoadingNextMsg);
    } else {
      scrollBottom();
      setPrevHeight(msgListRef?.current?.offsetHeight);
    }

    setIsLoadingMoreMsg(false);
    setIsLoadingNextMsg(false);
  }, [msgList]);

  const formattedMsgList = useMemo(() => {
    // check duplicate msg and rearrange
    const result = [];
    msgList.forEach((item) => {
      const { _id, fromId, toId } = item || {};
      const isCurrentObject = fromId === selectingId || toId === selectingId;
      if (
        result.every(({ _id: resId }) => {
          return resId !== _id;
        }) &&
        isCurrentObject
      ) {
        result.push(item);
      }
    });
    return result.sort(({ createdAt: a }, { createdAt: b }) => {
      return moment(a).diff(moment(b), "miliseconds");
    });
  }, [msgList, selectingId]);

  const getCurrentCoName = useMemo(() => {
    const { info } = listContact?.find(({ _id }) => selectingId === _id) || {};

    if (info) {
      return info?.customerId + info?.lastNameKanji;
    }
  }, [selectingId, listContact]);

  const onLoadMoreCustomer = () => {
    setListCusPage((prev) => prev + 1);
  };

  function getAllWithLastMessageApi(keyword = "", isReset = false, messageId) {
    if (listCusPage > 1) {
      messageId = undefined;
    }

    customerServices
      .getAllWithLastMessage(listCusPage, keyword, messageId)
      .then((res) => {
        const { currentPage, totalPages } = res?.data || {};
        if (currentPage >= totalPages) {
          setHasMoreCustomer(false);
        }

        const newCustomer = res?.data?.rows
          .filter(({ _id }) => _id !== ADMIN_CHAT_ID)
          .map(
            ({
               id: _id,
               companyNameKanji: firstNameKanji,
               customerId,
               timeLastMessage,
             }) => {
              return {
                _id,
                info: {
                  firstNameKanji,
                  lastNameKanji: "",
                  customerId,
                },
                timeLastMessage,
              };
            }
          );

        setListContact((prev) => {
          if (isReset) {
            return newCustomer;
          }
          const data = [...prev, ...(newCustomer || [])] || []
          return data.filter((value, index, self) =>
            self.findIndex(v => v._id === value._id) === index
          );
        });

        // if (!newCustomer.find((item) => item._id === selectingId)) {
        //   setSelectingId(null);
        // }

        if (listCusPage == 1 && messageId && newCustomer?.[0]?._id) {
          const selectId = newCustomer[0]?._id
          setSelectingId(selectId);
          handleMessageSelected(messageId, false)
        }

      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  // const debounceDropDown = useCallback(
  //   debounce((nextValue) => {
  //     getAllWithLastMessage(nextValue, true);

  //     if (selectingId) {
  //       socket?.emit("join-room", {
  //         toId: selectingId,
  //         fromId: ADMIN_CHAT_ID,
  //         offset: 0,
  //         perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
  //         keyword: nextValue,
  //       });
  //     }

  //     setIsSearch(nextValue.length > 0);
  //     setOffset(0);
  //   }, 1000),
  //   [selectingId]
  // );

  const onSearch = () => {
    setListCusPage(1)
    getAllWithLastMessageApi(keyword, true,);

    if (selectingId) {
      socket?.emit("join-room", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: 0,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        keyword: keyword,
      });
    }

    setIsSearch(keyword.length > 0);
    setOffset(0);
  };

  function handleKeywordOnchange(value) {
    setSelectedChatId(null);
    setKeyword(value);
    // debounceDropDown(value);
  }

  function handleMessageSelected(id, reload = true) {
    setKeyword("");
    setOffset(0);
    setOffsetNext(0);
    setIsSearch(false);
    setSelectedChatId(id);

    reload && getAllWithLastMessageApi("", true);

    if (selectingId) {
      socket?.emit("join-room", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: 0,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        chatId: id,
      });

      socket?.emit("load-next-msg", {
        toId: selectingId,
        fromId: ADMIN_CHAT_ID,
        offset: 0,
        perPage: DEFAULT_MSG_NUMBER_PER_PAGE,
        chatId: id,
      });

      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ block: "center" });
      }, 100);
    }
  }

  return (
    <ContentLayout
      selectingId={selectingId}
      onSelect={setSelectingId}
      listContact={listContact}
      onLoadMore={onLoadMoreCustomer}
      hasMore={hasMoreCustomer}
      keyword={keyword}
      handleKeywordOnchange={handleKeywordOnchange}
      handleOnSearch={() => {
        onSearch();
      }}
    >
      <div className="h-full flex flex-col flex-1 gap-[1.3em]">
        <div className="w-full px-4 min-h-[40px] py-2 bg-[#001C4F] text-white">
          {getCurrentCoName}
        </div>
        <div
          onScroll={handleScrollMsgList}
          id="msg-list-id"
          className="flex-1 overflow-y-auto"
        >
          <div ref={msgListRef} className="flex flex-col gap-4">
            {formattedMsgList?.map(
              ({ isIncomingMsg, content, createdAt, _id }) => {
                return (
                  <MessageCard
                    key={_id}
                    id={_id}
                    isIncomingMsg={isIncomingMsg}
                    content={content}
                    createdAt={createdAt}
                    isSearch={isSearch}
                    highlight={currentMessageId === _id}
                    handleMessageSelected={handleMessageSelected}
                  />
                );
              }
            )}
          </div>
        </div>
        {selectingId && !isSearch && (
          <div className="flex-[0_0_82px]">
            <ChatBox
              textAreaRef={textAreaRef}
              msgVal={msgVal}
              setMsgVal={setMsgVal}
              handleSendMsg={handleSendMsg}
            />
            <div className="flex justify-end gap-4 mt-2">
              <Button type="danger">クリア</Button>
              <Button onClick={handleSendMsg}>送信する</Button>
            </div>
          </div>
        )}
      </div>
    </ContentLayout>
  );
}

export default function ChatPage() {
  const [socket, setSocket] = useState();

  useVerifyToken();

  useEffect(() => {
    setSocket(socketConfig());
  }, []);
  if (socket) {
    return <ChatContent socket={socket} />;
  }
}
